export const CRASH_GAME = '/crash-game'
export const PLINKO_GAME = '/plinko-game'
export const PYRAMID_PLINKO_GAME = '/pyramid-plinko-game'
export const MINE_GAME = '/mine-game'
export const WALLET = '/wallet'
export const SYSTEM = '/system'
export const PUMP_BALLOON_GAME = '/pump-balloon-game'
export const FOOTBALL_X_GAME = '/football-x-game'
export const AIR_GOAL_GAME = '/air-goal-game'
export const GAMIFICATION = '/gamification'

export const SOCKET_EMITTERS = {
  PUMP_BALLOON_GAME_PLACE_BET: PUMP_BALLOON_GAME + '/placeBet',
  PUMP_BALLOON_GAME_PLAY_GAME: PUMP_BALLOON_GAME + '/playGame',
  PUMP_BALLOON_GAME_CASH_OUT: PUMP_BALLOON_GAME + '/cashOutBet',
  // Football x game
  FOOTBALL_X_GAME_PLACE_BET: FOOTBALL_X_GAME + '/placeBet',
  FOOTBALL_X_GAME_PLAY_GAME: FOOTBALL_X_GAME + '/playGame',
  FOOTBALL_X_GAME_CASH_OUT: FOOTBALL_X_GAME + '/cashOutBet',

  AIR_GOAL_GAME_PLACE_BET: AIR_GOAL_GAME + '/placeBet',
  AIR_GOAL_GAME_PLAY_GAME: AIR_GOAL_GAME + '/playGame',
  AIR_GOAL_GAME_CASH_OUT: AIR_GOAL_GAME + '/cashOutBet'
}

export const SOCKET_LISTENERS = {
  // Football x game
  PUMP_BALLOON_GAME_PLACE_BET: PUMP_BALLOON_GAME + '/placeBet',
  PUMP_BALLOON_GAME_PLAY_GAME: PUMP_BALLOON_GAME + '/playGame',
  PUMP_BALLOON_GAME_CASH_OUT: PUMP_BALLOON_GAME + '/cashOut',
  PUMP_BALLOON_GAME_BUSTED_GAME: PUMP_BALLOON_GAME + '/bustedGame',

  // Football x game
  FOOTBALL_X_GAME_PLACE_BET: FOOTBALL_X_GAME + '/placeBet',
  FOOTBALL_X_GAME_PLAY_GAME: FOOTBALL_X_GAME + '/playGame',
  FOOTBALL_X_GAME_CASH_OUT: FOOTBALL_X_GAME + '/cashOut',
  FOOTBALL_X_GAME_BUSTED_GAME: FOOTBALL_X_GAME + '/bustedGame',


  AIR_GOAL_GAME_PLACE_BET: AIR_GOAL_GAME + '/placeBet',
  AIR_GOAL_GAME_PLAY_GAME: AIR_GOAL_GAME + '/playGame',
  AIR_GOAL_GAME_CASH_OUT: AIR_GOAL_GAME + '/cashOut',
  AIR_GOAL_GAME_BUSTED_GAME: AIR_GOAL_GAME + '/bustedGame',
}

const NAMESPACES = {
  CRASH_GAME: '/crash-game',
  AZTECMAN_GAME: '/aztecman-game',
  FOLLOW_THE_ARROW_GAME: '/follow-the-arrow-game',
  POWER_OF_THOR_GAME: '/power-of-thor-game',
  CHAT: '/chat'
}

export default NAMESPACES
